import styled from 'styled-components';
import { Modal } from 'react-bootstrap';
import CustomInput from '~/components/layout/CustomInput'
import { ReactComponent as IconMailSvg } from "~/assets/icons/email-icon.svg";
import CustomButton from '~/components/layout/CustomButton';

export const Container = styled(Modal.Body)`
  background-color: #ffffff;
  border-radius: 8px;
  width: 100%;
  height: auto;
  padding: 30px;
  overflow-x: hidden;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 10px;
  align-items: flex-start;
`;

export const Title = styled.span`
  font-size: 26px;
  color: #0B29FB;
  @media (max-width: 375px) {
    font-size: 23px;
  }
`;

export const CloseIcon = styled.span`
  font-size: 20px;
  margin-top: -50px;
  margin-right: -11px;
  color: #0000008a;
  cursor: pointer;
  @media (max-width: 370px) {
    font-size: 18px;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: auto;
`;

export const IconEmail = styled(IconMailSvg)`
  margin-top: 6px;
`;

export const InputEmail = styled(CustomInput)`
  margin-top: 23px;

  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const SubTitle = styled.span``;

export const ButtonNext = styled(CustomButton)`
  margin-top: 46px;
  margin-bottom: 23px;

  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const SuccessContainer = styled.div`
  display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const IconSuccessContainer = styled.div``;

export const SuccessMsg = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
  color: #777880;
  margin-top: 22px;
  max-width: 212px;
`;
